/* eslint-disable react-hooks/exhaustive-deps */
import PropTypes from "prop-types";
import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import { useLocation } from "react-router-dom";

import {
  changeLayout,
  changeLayoutWidth,
  changeSidebarTheme,
  changeSidebarType,
  changeTopbarTheme,
} from "../../store/actions";

import OtpUnlockModal from "../Common/OtpUnlockModal";
import Rightbar from "../CommonForBoth/Rightbar";
import { STORAGEKEY } from "../Constant";
import Footer from "./Footer";
import Header from "./Header";
import Sidebar from "./Sidebar";

const Layout = (props) => {
  const location = useLocation();
  const [isMobile] = useState(
    /iPhone|iPad|iPod|Android/i.test(navigator.userAgent),
  );

  const capitalizeFirstLetter = (string) => {
    if (!string) return "";
    return string.charAt(1).toUpperCase() + string.slice(2);
  };

  useEffect(() => {
    if (props.isPreloader === true) {
      document.getElementById("preloader").style.display = "block";
      document.getElementById("status").style.display = "block";

      setTimeout(() => {
        document.getElementById("preloader").style.display = "none";
        document.getElementById("status").style.display = "none";
      }, 2500);
    } else {
      document.getElementById("preloader").style.display = "none";
      document.getElementById("status").style.display = "none";
    }

    // Scroll to top
    window.scrollTo(0, 0);

    let currentPage = capitalizeFirstLetter(location.pathname);
    document.title = currentPage + " | BLUECPM";

    if (props.leftSideBarTheme) {
      props.changeSidebarTheme(props.leftSideBarTheme);
    }

    props.changeLayout("detached");

    if (props.layoutWidth) {
      props.changeLayoutWidth(props.layoutWidth);
    }

    if (props.leftSideBarType) {
      props.changeSidebarType(props.leftSideBarType);
    }

    if (props.topbarTheme) {
      props.changeTopbarTheme(props.topbarTheme);
    }
  }, [
    location.pathname,
    props.isPreloader,
    props.leftSideBarTheme,
    props.layoutWidth,
    props.leftSideBarType,
    props.topbarTheme,
  ]);

  const toggleMenuCallback = () => {
    if (props.leftSideBarType === "default") {
      props.changeSidebarType("condensed", isMobile);
    } else if (props.leftSideBarType === "condensed") {
      props.changeSidebarType("default", isMobile);
    }
  };

  return (
    <React.Fragment>
      <div id="preloader">
        <div id="status">
          <div className="spinner-chase">
            <div className="chase-dot"></div>
            <div className="chase-dot"></div>
            <div className="chase-dot"></div>
            <div className="chase-dot"></div>
            <div className="chase-dot"></div>
            <div className="chase-dot"></div>
          </div>
        </div>
      </div>
      <div className="container-fluid">
        <div id="layout-wrapper">
          <Header
            toggleMenuCallback={toggleMenuCallback}
            token={localStorage.getItem(STORAGEKEY.ACCESSTOKEN)}
          />
          <Sidebar
            theme={props.leftSideBarTheme}
            type={props.leftSideBarType}
            isMobile={isMobile}
          />
          <div className="main-content">
            {/* <UnlockTimerAlert /> */}
            {props.children}
            <OtpUnlockModal />
            <Footer />
          </div>
        </div>
      </div>
      {props.showRightSidebar ? <Rightbar /> : null}
    </React.Fragment>
  );
};

Layout.propTypes = {
  changeLayoutWidth: PropTypes.func,
  changeSidebarTheme: PropTypes.func,
  changeSidebarType: PropTypes.func,
  changeTopbarTheme: PropTypes.func,
  children: PropTypes.node,
  isPreloader: PropTypes.any,
  layoutWidth: PropTypes.any,
  leftSideBarTheme: PropTypes.any,
  leftSideBarType: PropTypes.any,
  showRightSidebar: PropTypes.any,
  topbarTheme: PropTypes.any,
};

const mapStatetoProps = (state) => {
  return {
    ...state.Layout,
  };
};

export default connect(mapStatetoProps, {
  changeLayout,
  changeSidebarTheme,
  changeSidebarType,
  changeTopbarTheme,
  changeLayoutWidth,
})(Layout);
